import Vue from 'vue'
import VueRouter from 'vue-router'
import { Layout, RouteTitle, Url } from '@/utility/constants'

const Home = () => import('../views/home/Home.vue')
const HelpfulDocuments = () => import('../views/helpfulDocuments/HelpfulDocuments.vue')
const PriorAuthCriteria = () => import('../views/priorAuthCriteria/PriorAuthCriteria.vue')
const Wellness = () => import('../views/wellness/Wellness.vue')
const Contact = () => import('../views/contact/Contact.vue')

// This was for internal member portal management
//const SignIn = () => import('../views/signIn/SignIn.vue')
//const BenefitOverview = () => import('../views/benefitOverview/BenefitOverview.vue')
//const DrugLists = () => import('../views/drugLists/DrugLists.vue')
//const IdCard = () => import('../views/idCard/IdCard.vue')

// PageNotFound
const PageNotFound = () => import('../views/shared/404.vue')

// Shared
const Route = () => import('../components/shared/Route.vue')

Vue.use(VueRouter)

const routes = [
    {
        path: Url.HOMEPAGE,
        component: Home,
        meta: { layout: Layout.MAIN, auth: false }
    },

    {
        path: Url.HELPFUL_DOCUMENTS,
        component: HelpfulDocuments,
        meta: { title: RouteTitle.HELPFUL_DOCUMENTS, layout: Layout.MAIN, auth: false }
    },

    {
        path: Url.PRIOR_AUTH_CRITERIA,
        component: PriorAuthCriteria,
        meta: { title: RouteTitle.PRIOR_AUTH_CRITERIA, layout: Layout.MAIN, auth: false }
    },

    {
        path: Url.WELLNESS,
        component: Wellness,
        meta: { title: RouteTitle.WELLNESS, layout: Layout.MAIN, auth: false }
    },

    {
        path: Url.CONTACT_US,
        component: Contact,
        meta: { title: RouteTitle.CONTACT_US, layout: Layout.MAIN, auth: false }
    },

    {
        path: Url.MY_BENEFITS_OLD,
        component: Route,

        beforeEnter: () => {
            window.location.href = Url.MY_BENEFITS
        },

        children: [
            {
                path: '*',

                beforeEnter: () => {
                    window.location.href = Url.MY_BENEFITS
                }
            },
        ]

        // This was for internal member portal management
        //children: [
        //    {
        //        path: '/',
        //        redirect: Url.MY_BENEFITS_OVERVIEW
        //    },

        //    {
        //        name: RouteName.SIGN_IN,
        //        path: Url.SIGN_IN,
        //        component: SignIn,
        //        props: true,
        //        meta: { title: RouteTitle.SIGN_IN, layout: Layout.MAIN, auth: false }
        //    },

        //    {
        //        path: Url.MY_BENEFITS_OVERVIEW,
        //        component: BenefitOverview,
        //        meta: { title: RouteTitle.MY_BENEFITS_OVERVIEW, layout: Layout.MAIN, auth: true }
        //    },

        //    {
        //        path: Url.DRUG_LISTS,
        //        component: DrugLists,
        //        meta: { title: RouteTitle.DRUG_LISTS, layout: Layout.MAIN, auth: true }
        //    },

        //    {
        //        path: Url.MY_PHARMACY_LOCATOR,
        //        component: PharmacyLocator,
        //        meta: { title: RouteTitle.MY_PHARMACY_LOCATOR, layout: Layout.MAIN, auth: true }
        //    },

        //    {
        //        path: Url.ID_CARD,
        //        component: IdCard,
        //        meta: { title: RouteTitle.ID_CARD, layout: Layout.MAIN, auth: true }
        //    }
        //]
    },

    {
        path: '*',
        name: '404',
        component: PageNotFound,
        meta: { layout: Layout.DEFAULT, auth: false }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

router.afterEach((to) => {
    if (to.meta && to.meta.title) {
        document.title = RouteTitle.DEFAULT_TITLE + ' - ' + to.meta.title
    } else {
        document.title = RouteTitle.DEFAULT_TITLE
    }
})

export default router
